var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getChatSessions } from '../services/chatSessionsApi';
const CONVERSATIONS_KEY = ['ai-chat', 'conversations'];
export function useChatHistory() {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: CONVERSATIONS_KEY,
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const result = yield getChatSessions({ perPage: 50 });
            return result.conversations;
        }),
        staleTime: 30000,
        refetchOnWindowFocus: false
    });
    return {
        conversations: data || [],
        isLoading,
        error: error instanceof Error ? error : null,
        refetch: () => {
            void refetch();
        }
    };
}
export function useInvalidateConversations() {
    const queryClient = useQueryClient();
    return () => {
        void queryClient.invalidateQueries({ queryKey: CONVERSATIONS_KEY });
    };
}
